import { render, staticRenderFns } from "./SpecificationPage.vue?vue&type=template&id=890f6bfa&scoped=true&lang=pug&"
import script from "./SpecificationPage.vue?vue&type=script&lang=js&"
export * from "./SpecificationPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationPage.vue?vue&type=style&index=0&id=890f6bfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f6bfa",
  null
  
)

export default component.exports